import { Pipe, PipeTransform, inject } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { tr } from "./i18n";

/**
 * `{{ 'Prenotazioni' | t }}` shows the text in the current language.
 * Impure so it re-evaluates when the language changes.
 */
@Pipe({ name: "t", standalone: true, pure: false })
export class TPipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  transform(text: string, params?: Record<string, string | number>): string {
    // reading currentLang keeps the pipe tied to language changes
    void this.translate.currentLang;
    return tr(text, params);
  }
}
